(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[144],{

/***/ "0fIf":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var lastIndexOf = __webpack_require__("QsAM");

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),

/***/ "G5yF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx + 2 modules
var SliderHandler = __webpack_require__("A5Hi");

// CONCATENATED MODULE: ./src/client/components/frameworks/content-slideshow/ContentSlideShow.jsx
var __jsx = react_default.a.createElement;






var ContentSlideShow_ContentSlideShow = function ContentSlideShow(_ref) {
  var children = _ref.children,
      className = _ref.className;

  if (!react["Children"].count(children)) {
    return null;
  }

  return __jsx(SliderHandler["a" /* SliderHandler */], {
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: children
  }, function (_ref2) {
    var hasControls = _ref2.hasControls,
        isNextControlDisabled = _ref2.isNextControlDisabled,
        isPreviousControlDisabled = _ref2.isPreviousControlDisabled,
        itemsNode = _ref2.itemsNode,
        onNext = _ref2.onNext,
        onPrevious = _ref2.onPrevious;
    return __jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('flex items-center justify-center gap-15', className)
    }, hasControls && __jsx(ArrowButton["a" /* ArrowButton */], {
      className: Object(classnames_utils["a" /* classnames */])('flex-none shadow-sm', {
        invisible: isPreviousControlDisabled
      }),
      color: colors["a" /* COLORS */].WHITE,
      isDisabled: isPreviousControlDisabled,
      label: Object(i18n["h" /* t */])('common.previous'),
      onClick: onPrevious
    }), itemsNode, hasControls && __jsx(ArrowButton["a" /* ArrowButton */], {
      className: Object(classnames_utils["a" /* classnames */])('flex-none shadow-sm', {
        invisible: isNextControlDisabled
      }),
      color: colors["a" /* COLORS */].WHITE,
      isDisabled: isNextControlDisabled,
      label: Object(i18n["h" /* t */])('common.next'),
      onClick: onNext,
      rotation: 180
    }));
  });
};
// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-awards/TripAdvisorAwards.jsx


var TripAdvisorAwards_jsx = react_default.a.createElement;



var TripAdvisorAwards_TripAdvisorAwards = function TripAdvisorAwards(_ref) {
  var _ref$awards = _ref.awards,
      awards = _ref$awards === void 0 ? [] : _ref$awards,
      className = _ref.className;

  if (isEmpty_default()(awards)) {
    return null;
  }

  return TripAdvisorAwards_jsx("section", {
    className: className
  }, TripAdvisorAwards_jsx(ContentSlideShow_ContentSlideShow, null, awards.map(function (_ref2) {
    var altMsg = _ref2.altMsg,
        imageUrl = _ref2.imageUrl;
    return imageUrl ? TripAdvisorAwards_jsx("article", {
      className: "overflow-hidden px-5 text-center leading-0",
      key: imageUrl
    }, TripAdvisorAwards_jsx(Image["a" /* Image */], {
      altMsg: altMsg,
      className: "mx-auto",
      classNameImg: "max-h-140",
      dontChangeAnything: true,
      imageUrl: imageUrl
    })) : null;
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-ratings/TripAdvisorRatings.jsx




var TripAdvisorRatings_jsx = react_default.a.createElement;


var TripAdvisorRatings_TripAdvisorRatings = function TripAdvisorRatings(_ref) {
  var className = _ref.className,
      counterLabel = _ref.counterLabel,
      counterUnit = _ref.counterUnit,
      counterValue = _ref.counterValue,
      _ref$image = _ref.image,
      image = _ref$image === void 0 ? {} : _ref$image,
      _ref$subratings = _ref.subratings,
      subratings = _ref$subratings === void 0 ? [] : _ref$subratings;

  if (isEmpty_default()(subratings)) {
    return null;
  }

  return TripAdvisorRatings_jsx("section", {
    className: className
  }, TripAdvisorRatings_jsx("div", {
    className: "flex items-center justify-center"
  }, !isEmpty_default()(image) ? TripAdvisorRatings_jsx(Image["a" /* Image */], Object(esm_extends["a" /* default */])({
    className: "my-5",
    dontChangeAnything: true
  }, image)) : null, TripAdvisorRatings_jsx("span", null, "\xA0"), TripAdvisorRatings_jsx("p", {
    className: "text-14"
  }, counterLabel, TripAdvisorRatings_jsx("span", null, " "), TripAdvisorRatings_jsx("span", {
    className: "text-[#429E96]"
  }, [counterValue, counterUnit].join(' ')))), TripAdvisorRatings_jsx("ul", {
    className: "mx-auto mt-30 w-[290px] px-5"
  }, subratings.map(function (_ref2) {
    var localizedName = _ref2.localizedName,
        ratingImageUrl = _ref2.ratingImageUrl,
        value = _ref2.value;

    if (isEmpty_default()(subratings[0])) {
      return null;
    }

    return TripAdvisorRatings_jsx("li", {
      className: "mx-auto mt-5 flex w-full items-center justify-between gap-5",
      key: localizedName
    }, TripAdvisorRatings_jsx("span", {
      className: "leading-1"
    }, localizedName), TripAdvisorRatings_jsx("span", {
      className: "w-80 leading-0"
    }, TripAdvisorRatings_jsx(Image["a" /* Image */], {
      className: "w-full",
      classNameImg: "max-h-16 w-full",
      altMsg: "".concat(value),
      dontChangeAnything: true,
      imageUrl: ratingImageUrl,
      dimensions: {
        w: 80,
        h: 17
      }
    })));
  })));
};
// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-reviews/TripAdvisorReviews.jsx


var TripAdvisorReviews_jsx = react_default.a.createElement;






var TripAdvisorReviews_TripAdvisorReviews = function TripAdvisorReviews(_ref) {
  var className = _ref.className,
      _ref$maxLengthOfRevie = _ref.maxLengthOfReview,
      maxLengthOfReview = _ref$maxLengthOfRevie === void 0 ? 255 : _ref$maxLengthOfRevie,
      _ref$reviews = _ref.reviews,
      reviews = _ref$reviews === void 0 ? [] : _ref$reviews;
  var track = Object(useTracking["a" /* useTracking */])();

  if (isEmpty_default()(reviews)) {
    return null;
  }

  return TripAdvisorReviews_jsx("section", {
    className: className
  }, TripAdvisorReviews_jsx(ContentSlideShow_ContentSlideShow, null, reviews.map(function (_ref2) {
    var datetime = _ref2.datetime,
        rating = _ref2.rating,
        ratingImageUrl = _ref2.ratingImageUrl,
        _ref2$authors = _ref2.authors,
        authors = _ref2$authors === void 0 ? [] : _ref2$authors,
        date = _ref2.date,
        text = _ref2.text,
        title = _ref2.title,
        url = _ref2.url;

    if (isEmpty_default()(text)) {
      return null;
    }

    return TripAdvisorReviews_jsx(DynamicLink["a" /* default */], {
      className: "block text-inherit",
      key: url,
      onClick: function onClick() {
        return track({
          actionGA: 'practicalInfos',
          categoryGA: 'resort',
          labelGA: 'tripAdvisorReviews'
        });
      },
      target: "_blank",
      url: url
    }, TripAdvisorReviews_jsx("blockquote", {
      cite: url,
      className: "m-0"
    }, title && TripAdvisorReviews_jsx("p", {
      className: "font-bold mb-10",
      title: title
    }, title), TripAdvisorReviews_jsx("div", {
      className: "flex gap-15 items-center mb-10"
    }, TripAdvisorReviews_jsx(Image["a" /* Image */], {
      altMsg: "".concat(rating),
      dontChangeAnything: true,
      imageUrl: ratingImageUrl
    }), TripAdvisorReviews_jsx("time", {
      dateTime: datetime,
      className: "text-12"
    }, date)), text && TripAdvisorReviews_jsx("p", {
      className: "mb-10 before:content-['\u201C'] before:font-sans after:content-['\u201D'] after:font-sans",
      title: text
    }, Object(string_util["d" /* truncate */])(text, maxLengthOfReview)), TripAdvisorReviews_jsx("small", {
      className: "block text-12"
    }, TripAdvisorReviews_jsx("span", null, authors.map(function (author) {
      return TripAdvisorReviews_jsx("span", {
        key: author,
        "data-testid": "TripAdvisorReviewsAuthor"
      }, author, TripAdvisorReviews_jsx("br", null));
    })))));
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-large/TripAdvisorLarge.jsx


var TripAdvisorLarge_jsx = react_default.a.createElement;





var TripAdvisorLarge_TripAdvisorLarge = function TripAdvisorLarge(_ref) {
  var _ref$awards = _ref.awards,
      awards = _ref$awards === void 0 ? [] : _ref$awards,
      className = _ref.className,
      _ref$ratings = _ref.ratings,
      ratings = _ref$ratings === void 0 ? {} : _ref$ratings,
      reviews = _ref.reviews;

  if (isEmpty_default()(awards) && isEmpty_default()(ratings.subratings) && isEmpty_default()(reviews)) {
    return null;
  }

  var classes = 'border-1 border-lightGrey flex items-center justify-center p-15 rounded-12 w-1/3';
  return TripAdvisorLarge_jsx("section", {
    className: Object(classnames_utils["a" /* classnames */])('flex justify-center gap-20', className)
  }, !isEmpty_default()(ratings.subratings) && TripAdvisorLarge_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(classes, 'w-380')
  }, TripAdvisorLarge_jsx(TripAdvisorRatings_TripAdvisorRatings, Object(esm_extends["a" /* default */])({
    className: "w-full max-w-full"
  }, ratings, {
    subratings: ratings.subratings
  }))), !isEmpty_default()(reviews) && TripAdvisorLarge_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(classes, 'flex-1')
  }, TripAdvisorLarge_jsx(TripAdvisorReviews_TripAdvisorReviews, {
    className: "w-full max-w-full",
    maxLengthOfReview: 150 // $FlowFixMe
    ,
    reviews: reviews
  })), !isEmpty_default()(awards) && TripAdvisorLarge_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(classes, 'w-280')
  }, TripAdvisorLarge_jsx(TripAdvisorAwards_TripAdvisorAwards, {
    className: "w-full max-w-full",
    awards: awards
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-narrow/TripAdvisorNarrow.jsx



var TripAdvisorNarrow_jsx = react_default.a.createElement;





var TripAdvisorNarrow_TripAdvisorNarrow = function TripAdvisorNarrow(_ref) {
  var _ref$awards = _ref.awards,
      awards = _ref$awards === void 0 ? [] : _ref$awards,
      awardsLabel = _ref.awardsLabel,
      className = _ref.className,
      _ref$ratings = _ref.ratings,
      ratings = _ref$ratings === void 0 ? {} : _ref$ratings,
      ratingsLabel = _ref.ratingsLabel,
      reviews = _ref.reviews,
      reviewsLabel = _ref.reviewsLabel;

  var _useState = Object(react["useState"])(0),
      position = _useState[0],
      setPosition = _useState[1];

  var hasAwards = !isEmpty_default()(awards);
  var hasRatings = !isEmpty_default()(ratings.subratings);
  var hasReviews = !isEmpty_default()(reviews);

  if (!hasAwards && !hasRatings && !hasReviews) {
    return null;
  }

  var items = [];
  var nav = [];

  if (hasReviews) {
    items.push(TripAdvisorNarrow_jsx(TripAdvisorReviews_TripAdvisorReviews, {
      key: "reviews",
      className: "w-full" // $FlowFixMe
      ,
      reviews: reviews,
      maxLengthOfReview: 150
    }));
    nav.push(reviewsLabel);
  }

  if (hasRatings) {
    items.push(TripAdvisorNarrow_jsx(TripAdvisorRatings_TripAdvisorRatings, Object(esm_extends["a" /* default */])({}, ratings, {
      key: "ratings",
      className: "w-full",
      subratings: ratings.subratings
    })));
    nav.push(ratingsLabel);
  }

  if (hasAwards) {
    items.push(TripAdvisorNarrow_jsx(TripAdvisorAwards_TripAdvisorAwards, {
      key: "awards",
      className: "w-full self-center",
      awards: awards
    }));
    nav.push(awardsLabel);
  }

  return TripAdvisorNarrow_jsx("section", {
    className: Object(classnames_utils["a" /* classnames */])('mx-auto max-w-600', className)
  }, TripAdvisorNarrow_jsx("div", {
    className: "overflow-hidden rounded-12 border-1 border-lightGrey"
  }, TripAdvisorNarrow_jsx("div", {
    className: "transition-transform flex duration-250 ease-in",
    style: {
      transform: "translate(".concat(position * -100, "%, 0)")
    }
  }, items.map(function (item, idx) {
    return TripAdvisorNarrow_jsx("div", {
      "aria-hidden": position !== idx,
      className: Object(classnames_utils["a" /* classnames */])('flex min-w-full max-w-full overflow-hidden p-10', {
        invisible: position !== idx
      }),
      key: idx
    }, item);
  }))), TripAdvisorNarrow_jsx("div", {
    className: "relative flex"
  }, TripAdvisorNarrow_jsx("div", {
    className: "arrow-up arrow-white arrow-bg arrow-bg-sienna absolute border-t-1 border-sienna",
    style: {
      margin: "0 ".concat(100 / nav.length * position, "%"),
      transition: 'all .25s ease-in .2s',
      width: "".concat(100 / nav.length, "%")
    }
  }), nav.map(function (button, idx) {
    return TripAdvisorNarrow_jsx("button", {
      className: Object(classnames_utils["a" /* classnames */])('flex-1 py-20 text-center text-14 font-bold', {
        'text-black': idx !== position
      }, {
        'text-sienna': idx === position
      }),
      key: button,
      onClick: function onClick() {
        return setPosition(idx);
      },
      type: "button"
    }, TripAdvisorNarrow_jsx("span", {
      className: Object(classnames_utils["a" /* classnames */])('block px-10', {
        'border-s-1': idx > 0
      })
    }, button));
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor/TripAdvisor.jsx
var TripAdvisor_jsx = react_default.a.createElement;




var TripAdvisor_TripAdvisor = function TripAdvisor(props) {
  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  return isDesktop ? TripAdvisor_jsx(TripAdvisorLarge_TripAdvisorLarge, props) : TripAdvisor_jsx(TripAdvisorNarrow_TripAdvisorNarrow, props);
};
// CONCATENATED MODULE: ./src/client/components/lines/product-tripadvisor-line/ProductTripAdvisorLine.jsx

var ProductTripAdvisorLine_jsx = react_default.a.createElement;








var ProductTripAdvisorLine_ProductTripAdvisorLine = function ProductTripAdvisorLine(props) {
  var track = Object(useTracking["a" /* useTracking */])();
  var tripadvisor = props.tripadvisor;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!tripadvisor || !tripadvisor.tripAdvisorUrl) {
    return null;
  }

  var awards = tripadvisor.awards.map(function (_ref) {
    var displayName = _ref.displayName,
        _ref$images = _ref.images,
        images = _ref$images === void 0 ? {} : _ref$images;
    return {
      altMsg: displayName,
      imageUrl: images.large
    };
  });
  var awardsLabel = props.awards;
  var ratings = {
    counterLabel: props.basedOn,
    counterUnit: props.reviews,
    counterValue: tripadvisor.numReviews,
    image: {
      altMsg: tripadvisor.rating,
      imageUrl: tripadvisor.ratingImageUrl
    },
    subratings: tripadvisor.subratings,
    title: props.ratingTitle
  };
  var ratingsLabel = props.ratings;
  var reviews = tripadvisor.reviews.map(function (review) {
    return {
      authors: review.reviewAuthor,
      date: review.reviewDate,
      datetime: review.publishedDate,
      rating: review.rating,
      ratingImageUrl: review.ratingImageUrl,
      text: review.text,
      title: review.title,
      url: review.url
    };
  });
  var reviewsLabel = props.reviews;
  var tripAdvisorUrl = tripadvisor.tripAdvisorUrl;
  var tripAdvisorLineTitle = props.tripAdvisorLineTitle,
      tripAdvisorViewMoreLabel = props.tripAdvisorViewMoreLabel;
  return ProductTripAdvisorLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    "data-testid": "Line-TripadvisorBlock",
    id: "tripadvisor"
  }, ProductTripAdvisorLine_jsx("div", {
    className: "isolate relative"
  }, ProductTripAdvisorLine_jsx(LineTitle["a" /* LineTitle */], null, tripAdvisorLineTitle), isDesktop ? ProductTripAdvisorLine_jsx(TextLink["a" /* TextLink */], {
    className: "absolute end-0 top-0 underline",
    color: colors["a" /* COLORS */].BLACK,
    label: tripAdvisorViewMoreLabel,
    onClick: function onClick() {
      return track({
        actionGA: 'practicalInfos',
        categoryGA: 'resort',
        labelGA: 'tripAdvisorSeeMore'
      });
    },
    url: tripAdvisorUrl
  }) : null), ProductTripAdvisorLine_jsx(TripAdvisor_TripAdvisor, {
    awards: awards,
    awardsLabel: awardsLabel,
    ratings: ratings,
    ratingsLabel: ratingsLabel,
    reviews: reviews,
    reviewsLabel: reviewsLabel
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-tripadvisor/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ProductTripAdvisorLine_ProductTripAdvisorLine);

/***/ }),

/***/ "QsAM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var toIndexedObject = __webpack_require__("N4z3");
var toInteger = __webpack_require__("i7Kn");
var toLength = __webpack_require__("tJVe");
var arrayMethodIsStrict = __webpack_require__("f4p7");

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return $lastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ "tX1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return camelToSnakeCase; });
/* unused harmony export getValidString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return truncate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelCasify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return upperCaseLetterToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return snakeToCamel; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0fIf");
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nDih");
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_8__);










function getValidString(str) {
  return lodash_isString__WEBPACK_IMPORTED_MODULE_8___default()(str) ? str.trim() : '';
}

function truncate(str, characters) {
  var preserveWords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var strTrimed = getValidString(str);

  if (!characters) {
    return strTrimed;
  }

  if (characters < 0) {
    return '';
  }

  if (strTrimed.length > characters) {
    var length = preserveWords ? strTrimed.lastIndexOf(' ', characters) : characters;
    return strTrimed.substring(0, length) + '…';
  }

  return strTrimed;
}

function camelCasify(text) {
  return text.split(' ').map(function (word, i) {
    if (i > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    return word.toLowerCase();
  }).join('');
}

var upperCaseLetterToInt = function upperCaseLetterToInt(letter) {
  return letter.charCodeAt(0) - 64;
};

function snakeToCamel(s) {
  return s.replace(/(_\w)/g, function (match) {
    return match.toUpperCase().substr(1);
  });
}

var camelToSnakeCase = function camelToSnakeCase(str) {
  return str ? str.replace(/[A-Z]/g, function (letter) {
    return "_".concat(letter.toLowerCase());
  }) : '';
};



/***/ })

}]);